import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoreSelectedNavIconSecondary from './svgs/MoreSelectedNavIconSecondary.js';
import SvgMoreSelectedNavIcon from './svgs/MoreSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moreSelectedNavIcon = (props => useIcon(SvgMoreSelectedNavIcon, SvgMoreSelectedNavIconSecondary, props));

export { moreSelectedNavIcon as default };
